import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getChannelsByQuery } from '~/services/commissioner/commissioner-service.service.api';

import { GroupEntriesQueryKeys } from '../constants/query';

const STALE_TIME = 30_000;

export const useChannelSearch = (query: string, userId?: string) => {
  const { data, isFetching, isFetchingNextPage, fetchNextPage, hasNextPage } = useInfiniteQuery({
    enabled: query.length > 0 && Boolean(userId),
    queryKey: GroupEntriesQueryKeys.channelSearch(userId ?? '', query),
    queryFn: ({ pageParam = 1, signal }) =>
      getChannelsByQuery({ q: query, page: pageParam, pageSize: 20 }, signal),
    getNextPageParam: ({ page, totalPages }) => (page < totalPages ? page + 1 : undefined),
    staleTime: STALE_TIME,
    retry: false,
  });
  const results = useMemo(() => {
    const uniqueChannels = new Map<
      string,
      NonNullable<typeof data>['pages'][number]['data'][number]
    >();

    data?.pages.forEach((page) => {
      page.data.forEach((channel) => {
        const key = channel.userId ?? channel.id;
        if (!uniqueChannels.has(key)) uniqueChannels.set(key, channel);
      });
    });

    return Array.from(uniqueChannels.values());
  }, [data]);
  const result = {
    results,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage: hasNextPage ?? false,
  };
  return result;
};
